import useCheckPC from "@repo/hooks/utils/useCheckPC";
import useScrollLock from "@repo/hooks/utils/useScrollLock";
import type { IMenuQuery } from "@repo/shopify/src/queries/others-gql";
import classNames from "classnames";
import _uniqueId from "lodash/uniqueId";
import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";

import Footer from "@components/organisms/Footer";

import StoreNavMenuItems from "@molecules/NavMenu/StoreNavMenuItems";

import useLayout from "@hooks/reducerHooks/useLayout";

import { MENUS } from "@const/constants";

const storeUrl = "https://tuneglobal.myshopify.com/";

function StoreNav({ storeNav }: { storeNav: IMenuQuery | undefined }) {
  const { isHeaderOpen, closeHeader } = useLayout();
  const { isPC } = useCheckPC();

  const [storeOpen, setStoreOpen] = useState(true);

  /** Nav의 Store 항목이 열려있는지 확인하는 state **/

  const hideStoreNav = () => {
    Boolean(isHeaderOpen) && closeHeader();
  };

  useScrollLock();

  return (
    <div
      className={classNames(
        "bg-secondary text-quaternary pc:h-fit pc:px-5 fixed top-12.5 h-[calc(100dvh_-_50px)] w-full overflow-y-auto px-4 py-5",
      )}
      onMouseLeave={() => {
        isPC && hideStoreNav();
      }}
    >
      {isPC ? (
        <div className="grid grid-cols-8 gap-5">
          <StoreNavMenuItems storeNav={storeNav} />
        </div>
      ) : (
        /** 모바일 메뉴 */
        <>
          <ul className="flex flex-col gap-5">
            {MENUS.map(({ name, url }) => (
              <React.Fragment key={`left-menu-${name}-${_uniqueId()}`}>
                {name === "Shop" ? (
                  <li>
                    <span
                      className="cursor-pointer text-2xl leading-normal capitalize"
                      onClick={() => {
                        setStoreOpen(!storeOpen);
                      }}
                      role="presentation"
                    >
                      {name}
                    </span>
                    {storeOpen ? (
                      <div className="mt-5 flex flex-col gap-5 px-5">
                        <StoreNavMenuItems storeNav={storeNav} />
                      </div>
                    ) : null}
                  </li>
                ) : (
                  <li>
                    <Link
                      className="text-2xl leading-normal capitalize"
                      onClick={hideStoreNav}
                      to={url.replace(storeUrl, "")}
                    >
                      {name}
                    </Link>
                  </li>
                )}
              </React.Fragment>
            ))}
          </ul>
          {/** 모바일 메뉴의 푸터 구분 선 */}
          {/*<span className="bg-tuneGrey-300 my-10 block h-px w-full" />*/}
          {/** 모바일 메뉴의 푸터*/}
          {/*<Footer headerFoot />*/}
        </>
      )}
    </div>
  );
}

export default StoreNav;
